var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoading = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1010_1599)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1010_1599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.5333,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 28,
    r: 20.5333,
    fill: "#013BAE",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 53.4179C42.0379 53.4179 53.4179 42.0379 53.4179 28C53.4179 13.9621 42.0379 2.58212 28 2.58212C13.9621 2.58212 2.58212 13.9621 2.58212 28C2.58212 42.0379 13.9621 53.4179 28 53.4179ZM28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#0D223E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4292 29.9633C21.4026 29.9633 22.192 29.1741 22.192 28.2005C22.192 24.7808 24.9741 21.9985 28.394 21.9985H28.5632L28.0325 22.5293C27.3441 23.2176 27.3441 24.3338 28.0325 25.0221C28.721 25.7105 29.8368 25.7105 30.5255 25.022C30.5433 25.0042 34.0859 21.4611 34.0681 21.4791C34.7608 20.7835 34.7428 19.6701 34.0681 18.9925C33.95 18.8739 30.5433 15.4672 30.5255 15.4496C29.8371 14.7613 28.7213 14.7613 28.0325 15.4496C27.3441 16.138 27.3441 17.2541 28.0325 17.9425L28.5632 18.4732H28.394C23.0302 18.4732 18.6665 22.8369 18.6665 28.2007C18.6665 29.1741 19.4559 29.9633 20.4292 29.9633Z",
    fill: "#0D223E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3941 34.4026H28.2249L28.7557 33.8719C29.444 33.1835 29.444 32.0673 28.7557 31.379C28.0672 30.6906 26.951 30.6906 26.2626 31.3792C26.2448 31.397 22.7023 34.9401 22.7201 34.9223C22.0363 35.609 22.0358 36.7203 22.7199 37.4088C22.7608 37.4499 26.2263 40.9156 26.2626 40.9519C26.951 41.6402 28.0668 41.6404 28.7557 40.9519C29.444 40.2635 29.444 39.1474 28.7557 38.459L28.2249 37.9283H28.3941C33.758 37.9283 38.1216 33.5646 38.1216 28.2008C38.1216 27.2272 37.3323 26.438 36.3589 26.438C35.3855 26.438 34.5962 27.2272 34.5962 28.2008C34.5962 31.6203 31.8139 34.4026 28.3941 34.4026Z",
    fill: "#0D223E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1010_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1010_1599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoading);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loading.a7fe900352b0841fee41283b0e7e70d8.svg";